type Props = {
    minutes: number,
    size?: number,
}
const Calendar: React.FC<Props> = (props) => {
    const minutesInDay = 24 * 60;
    const days = Math.floor(props.minutes / minutesInDay);
    const remainingMinutes = props.minutes % minutesInDay;
    const hours = Math.floor(remainingMinutes / 60);
    const minutes = remainingMinutes % 60;

    const time = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;

    return (
        <>
        <div
            title="Mythos Event will trigger every midnight"
            style={{
                fontSize: "10pt",
                padding: "5px",
                marginRight: "10px",
                background: "rgba(212, 198, 172, .9)",
                borderRadius: "5px",
                color: "rgba(0, 0, 0, 0.85)",
                fontWeight: "600",
                textAlign: "center"
            }}
        >
            <span>Day {days}</span>
            <br />
            <span>{time}</span>
        </div>
        </>
    )
}
export default Calendar
